// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2_SDa0bpr5b4dKFEMLtbzd","imageContainer":"_3LHdVy8BFaMq90ylPSm5pv","male":"UE18leSFl0NTb2ilra2ei","min":"pzKekVYF3hNOWA1GC_SZd","female":"_8NeDW3OY3S3dosWJJuVLN"};